import React from 'react';
import { string } from 'prop-types';

const ArrowRightSmall = ({ color = 'fourth-color', fontSize = '13px', className = '' }) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_arrow_forward-main ${className}`}
  />
);

ArrowRightSmall.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default ArrowRightSmall;
